import RepositoryFactory from '@/shared/services/repositories/repository.factory';

export default class BaseService {
  repository;

  constructor(serviceName) {
    if (!serviceName) {
      throw new Error('Service name is required');
    }

    this.repository = RepositoryFactory.getRepository(serviceName);
  }

  handleResponse(response) {
    if (response && Object.prototype.hasOwnProperty.call(response, 'payload')) {
      return response.payload;
    }
    return response;
  }
}
